var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { environment as prod } from './environment.prod';
import { environment as dev } from './environment.dev';
var config = {
// Add common config values here
};
var configEnv = process.env.NODE_ENV === 'production'
    ? prod
    : dev;
export default __assign({}, config, configEnv);



//////////////////
// WEBPACK FOOTER
// ./src/config/index.ts
// module id = 131
// module chunks = 50